import useApi from "../services/ApiService";
import { Changelog, DocsManifest, DocsPage, DocsSearchEntry } from "../models/Docs";

export class DocsRepository {
  private api = useApi();

  async getManifest(): Promise<DocsManifest> {
    const response = await this.api.get("/api/docs");
    return response.data;
  }

  async getPage(slug: string): Promise<DocsPage> {
    const response = await this.api.get(`/api/docs/pages/${slug.split("/").map(encodeURIComponent).join("/")}`);
    return response.data;
  }

  async getSearchIndex(): Promise<DocsSearchEntry[]> {
    const response = await this.api.get("/api/docs/search");
    return response.data;
  }

  async getChangelog(): Promise<Changelog> {
    const response = await this.api.get("/api/docs/changelog");
    return response.data;
  }

  async markReleaseNotesSeen(release: string): Promise<void> {
    await this.api.post("/api/docs/changelog/seen", { release });
  }
}
